module.exports = __webpack_public_path__ + "static/media/burger.f8ab78eb.svg";